import React, { FunctionComponent } from 'react';
import { FormattedNumber } from 'react-intl';

type Props = {
  value: number;
};

const AMOUNT_LIMIT = 100;

const FormattedCurrency: FunctionComponent<Props> = ({ value }) => {
  if (value >= AMOUNT_LIMIT) {
    // Shows the amount without cents
    return (
      <FormattedNumber
        value={value}
        style="currency"
        currency="USD"
        minimumFractionDigits={0}
        maximumFractionDigits={0}
      />
    );
  }

  return <FormattedNumber value={value} style="currency" currency="USD" />;
};

export default FormattedCurrency;
